import React, { useEffect } from 'react';

// Custom color and icon mapping
const ALERT_STYLES = {
  error: {
    bg: '#f8d7da',
    color: '#721c24',
    border: '#f5c6cb',
    icon: '⛔'
  },
  success: {
    bg: '#d4edda',
    color: '#155724',
    border: '#c3e6cb',
    icon: '✅'
  },
  warning: {
    bg: '#fff3cd',
    color: '#856404',
    border: '#ffeeba',
    icon: '⚠️'
  },
  info: {
    bg: '#d1ecf1',
    color: '#0c5460',
    border: '#bee5eb',
    icon: 'ℹ️'
  }
};

const Alert = ({ message, type = 'error', onClose }) => {
  const style = ALERT_STYLES[type] || ALERT_STYLES.error;

  const alertStyle = {
    position: 'fixed',
    top: '20px',
    right: '20px',
    padding: '15px 20px',
    borderRadius: '4px',
    backgroundColor: style.bg,
    color: style.color,
    border: `1px solid ${style.border}`,
    zIndex: 1000,
    maxWidth: '400px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: '1rem'
  };

  useEffect(() => {
    if (!onClose) return;
    const timer = setTimeout(() => {
      onClose();
    }, 5000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div style={alertStyle}>
      <span>
        <span style={{ marginRight: 8 }}>{style.icon}</span>
        {message}
      </span>
      {onClose && (
        <button 
          onClick={onClose}
          style={{
            background: 'none',
            border: 'none',
            marginLeft: '10px',
            cursor: 'pointer',
            fontSize: '16px',
            color: 'inherit'
          }}
        >
          ×
        </button>
      )}
    </div>
  );
};

export default Alert;
